<template>
  <div class="w-100">
    <!-- search bar -->
    <b-input-group size="sm">
      <template #prepend>
        <b-input-group-text id="input-group-text-icon">
          <i class="fas fa-search"></i>
        </b-input-group-text>
      </template>
      <b-form-input
        type="text"
        v-model="value"
        autocomplete="off"
        :debounce="debounce"
        :placeholder="placeholder"
        id="input-group-text-search"
      ></b-form-input>
    </b-input-group>
  </div>
</template>

<script>
export default {
  props: {
    textValue: {
      type: String,
      default: '',
    },
    debounce: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  computed: {
    value: {
      get() {
        return this.textValue
      },
      set(newVal) {
        this.$emit('on-search', newVal)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
#input-group-text-icon {
  border-right: 0px;
  font-size: 1rem;
  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
  background-color: var(--secondaryBGColor) !important;
}
#input-group-text-search {
  padding: 0.15rem 0.75rem;
  border-left: 0px solid;
}
</style>
